import React, { useState } from 'react';
import { DERSLER } from '../../lib/dersler.js';
import { bosSlotSayisi, manifestSlotlari, manifestPublicNolar, KOVA_RENK } from './yardimcilar';
import { URUNLER } from './sabitler';
import SoruEkleci from './SoruEkleci';
// Faz C (2026-09-03): Basim.js'ten satır aralığıyla BİREBİR taşındı — davranış değişmedi.

// ═══════════════════════════════════════════════════════════════════════════
// DENEME LİSTESİ — ekleme/çıkarma (2026-08-20)
//
// Format KİLİTLİ (kullanıcı kararı): çıkarılan soru BOŞ SLOT bırakır ve boş
// slot varken basım açılmaz; 119 soruluk "ÖSYM denemesi" defoludur.
// Bağlam grubu üyesi çıkarılınca grubun tamamı boşalır (paylaşılan yönerge
// yetim kalmasın).
// ═══════════════════════════════════════════════════════════════════════════
function DenemeManifestPaneli({ manifest, not, yukleniyor, aktifSlot, apiUrl, mufredat,
                                onCikar, onOtoDoldur, onAta, onSlotIptal, onSlotSec,
                                onTumBoslariDoldur, onOlustur }) {
  const [acikTestler, setAcikTestler] = useState({});
  if (!manifest) {
    return (
      <div className="basim-yazdirilmaz mb-3 rounded-lg border border-dashed border-indigo-300 bg-indigo-50/50 p-3 text-[11px] text-indigo-900 flex items-center justify-between gap-3">
        <div>
          {not
            ? <span className="text-amber-800 font-semibold">⚠ {not}</span>
            : <>🧩 <strong>Deneme listesi henüz oluşturulmadı.</strong> Listeyi üretirseniz
              soruları tek tek çıkarıp değiştirebilir, sonra basabilirsiniz — önizleme ve
              PDF aynı soruları basar.</>}
        </div>
        <button onClick={onOlustur} disabled={yukleniyor}
          className="shrink-0 px-3 py-1.5 rounded-lg bg-indigo-600 text-white text-xs font-bold hover:bg-indigo-700 disabled:opacity-50">
          {yukleniyor ? '⏳ Hazırlanıyor...' : '🧩 Deneme Oluştur'}
        </button>
      </div>
    );
  }

  const bos = bosSlotSayisi(manifest);
  const toplam = manifestSlotlari(manifest).length;
  const mevcutNolar = manifestPublicNolar(manifest);

  return (
    <div className={`basim-yazdirilmaz mb-3 rounded-lg border p-2.5 text-[11px] ${
      bos > 0 ? 'bg-amber-50 border-amber-300 text-amber-900' : 'bg-white border-indigo-200 text-gray-800'}`}>
      {/* `not` (sunucu X'i UYGULAMADI / liste bayatladi) ONCEDEN YALNIZ manifest
          YOKKEN basiliyordu: liste geldiginde uyari sessizce dusuyordu — yani
          "sunucu konu seviyesini uygulamadi" uyarisi fiilen hic gorunmuyordu
          (2026-09-21 tarih araligi testinde olculdu). Liste varken de basilir. */}
      {not && (
        <div data-manifest-not className="mb-2 rounded border border-amber-300 bg-amber-50 px-2 py-1 text-amber-900 font-semibold">
          ⚠ {not}
        </div>
      )}
      <div className="flex flex-wrap items-center justify-between gap-2 mb-2">
        <div className="font-bold">
          🧩 Deneme Listesi — {(Object.values(URUNLER).find(u => u.sinav === manifest.sinav) || {}).ad || manifest.sinav} · {toplam} soru
          {bos > 0
            ? <span className="text-red-700"> · {bos} BOŞ SLOT (basım kilitli)</span>
            : <span className="text-green-700"> · hazır</span>}
        </div>
        <div className="flex gap-1.5">
          {bos > 0 && (
            <button onClick={onTumBoslariDoldur} disabled={yukleniyor}
              className="px-2 py-1 rounded bg-amber-600 text-white text-[11px] font-bold hover:bg-amber-700 disabled:opacity-50">
              {yukleniyor ? '⏳' : `✨ Boşları otomatik doldur (${bos})`}
            </button>
          )}
          <button onClick={onOlustur} disabled={yukleniyor}
            title="Listeyi baştan üret — elle yaptığınız değişiklikler kaybolur"
            className="px-2 py-1 rounded bg-white border border-gray-300 text-[11px] font-semibold hover:bg-gray-50 disabled:opacity-50">
            🔄 Baştan üret
          </button>
        </div>
      </div>

      {manifest.testler.map(t => {
        const testBos = t.dersler.reduce((a, d) => a + d.sorular.filter(x => !x).length, 0);
        const acik = acikTestler[t.kod] ?? (testBos > 0);
        return (
          <div key={t.kod} className="mb-1.5 border-t border-gray-200 pt-1.5">
            <button onClick={() => setAcikTestler(o => ({ ...o, [t.kod]: !acik }))}
              className="w-full flex items-center gap-2 text-left font-semibold hover:opacity-70">
              <span>{acik ? '▼' : '▶'}</span>
              <span>{t.ad}</span>
              <span className="opacity-60">({t.dersler.reduce((a, d) => a + d.kota, 0)} soru)</span>
              {testBos > 0 && <span className="text-red-700 font-bold">· {testBos} boş</span>}
            </button>
            {acik && t.dersler.map(d => (
              <div key={d.ders} className="mt-1 ml-4">
                <div className="text-[10px] font-bold uppercase opacity-60 mb-0.5">
                  {d.ad || DERSLER.find(x => x.value === d.ders)?.label || d.ders} · {d.kota}
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-3">
                  {d.sorular.map((x, i) => (
                    <div key={`${d.ders}-${i}`}
                      className={`flex items-center gap-1.5 py-0.5 px-1 rounded ${
                        !x ? 'bg-red-100' : 'hover:bg-gray-50'}`}>
                      <span className="w-5 text-right opacity-50 tabular-nums">{i + 1}.</span>
                      {x ? (
                        <>
                          <span className="font-mono bg-gray-700 text-white px-1 rounded text-[10px]">#{x.public_no}</span>
                          <span className="flex-1 truncate" title={`${x.konu || ''} · ${x.kazanim_kodu || ''}`}>
                            {x.konu || '—'}
                          </span>
                          {x.zorluk_puan != null && (
                            <span className={`px-1 rounded text-[9px] font-bold ${KOVA_RENK[x.zorluk_kova] || ''}`}
                              title={`öğretmen puanı ${x.zorluk_puan} — ${x.zorluk_kova}`}>
                              {x.zorluk_puan}
                            </span>
                          )}
                          {x.gorselli && <span title="görselli soru">🖼</span>}
                          {x.baglam_grubu && <span title="Bağlam grubu üyesi — çıkarılırsa grubun tamamı çıkar">🔗</span>}
                          {x.yayinevi_isaretli && <span title="Yayınevine verilmiş">📕</span>}
                          {x.kova_kaynak === 'yedek' && <span title="İçerik hatası nedeniyle otomatik yedeklendi">⟳</span>}
                          <button onClick={() => onCikar(d.ders, i)} title="Bu soruyu çıkar"
                            className="px-1 rounded text-red-600 hover:bg-red-100 font-bold">✕</button>
                        </>
                      ) : (
                        <>
                          <span className="flex-1 text-red-700 font-semibold italic">boş slot</span>
                          <button onClick={() => onOtoDoldur(d.ders, i, 'orta')}
                            className="px-1.5 rounded bg-amber-200 text-amber-900 font-semibold hover:bg-amber-300">
                            otomatik
                          </button>
                          <button onClick={() => onSlotSec(d.ders, i)}
                            className={`px-1.5 rounded font-semibold ${
                              aktifSlot && aktifSlot.ders === d.ders && aktifSlot.idx === i
                                ? 'bg-blue-600 text-white' : 'bg-blue-100 text-blue-700 hover:bg-blue-200'}`}>
                            + soru seç
                          </button>
                        </>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        );
      })}

      {aktifSlot && (() => {
        // slot-ders (2026-09-03): slot etiketi/havuz/önek manifestteki ders girişinden.
        const aktifBlok = (manifest?.testler || []).flatMap(t => t.dersler).find(d => d.ders === aktifSlot.ders) || {};
        const aktifEtiket = aktifBlok.ad || DERSLER.find(x => x.value === aktifSlot.ders)?.label || aktifSlot.ders;
        const aktifHavuz = aktifBlok.havuz_ders || aktifSlot.ders;
        const aktifOnek = (aktifBlok.kazanim_onek || [])[0] || '';
        return (
        <div className="mt-2 border-t-2 border-blue-300 pt-2">
          <div className="flex items-center justify-between mb-1">
            <div className="font-bold text-blue-800">
              ➕ {aktifEtiket} ·
              {' '}{aktifSlot.idx + 1}. slot için soru seçin
            </div>
            <button onClick={onSlotIptal} className="px-2 py-0.5 rounded hover:bg-gray-100">✕ Kapat</button>
          </div>
          <SoruEkleci apiUrl={apiUrl} mevcutIds={[]} mevcutPublicNolar={mevcutNolar}
            sabitDers={aktifHavuz} sabitKazanimOnek={aktifOnek} sabitMufredat={mufredat}
            onEkle={(soru) => onAta(aktifSlot.ders, aktifSlot.idx, {
              public_no: soru.public_no, id: soru.id, ders: aktifSlot.ders, havuz_ders: soru.ders || aktifHavuz,
              konu: soru.konu, kazanim_kodu: soru.kazanim_kodu,
              zorluk_puan: soru.zorluk_puan ?? null,
              zorluk_kova: soru.zorluk_puan == null ? 'orta'
                : (soru.zorluk_puan <= 4 ? 'kolay' : soru.zorluk_puan >= 7 ? 'zor' : 'orta'),
              kova_kaynak: 'elle', test_kod: null, test_ici_no: null,
              baglam_grubu: soru.baglam_grubu || null, gorselli: false,
              yayinevi_isaretli: false,
            })}
            onTopluEkle={() => {}} />
        </div>
        );
      })()}
    </div>
  );
}

export default DenemeManifestPaneli;
